import { modules } from '@autofact/autofact-lib-ts-names';

export default modules;
